import React from 'react'
import PageBanner from '../Components/PageBanner'
import ServicesOne from '../Components/Services/ServicesOne'
import ServicesCta from '../Components/Services/ServicesCta'
import BestFeatures from '../Components/Features/BestFeatures'
import Pricing from '../Components/Price/Pricing'
import FaqOne from '../Components/Faq/FaqOne'
import bannerBg from '../assets/img/Banners/Management.jpg';
import { Link } from "react-router-dom";
 
import coreImg1 from "../assets/img/home1/Naginbhai.jpg";
import coreImg2 from "../assets/img/home1/Manishbhai.jpg";
import coreImg3 from "../assets/img/home1/Chetanbhai.jpg";

const Management = () => {
  return (
    <>
       <PageBanner title="Management    " bannerBg={bannerBg} currentPage="Management " />
       <section className="content-block-wrapper section-padding bg-circle fix">
        <div className="container">
          <div className="row  ">
            <div className="col-xl-3 col-lg-3 pe-xl-4 col-12"  style={{
                display:"flex",
                justifyContent:"center"
              }}>
              <div className="content-block-img  " >
                <img src={coreImg1} alt=""  style={{
                    maxWidth:"100%",
                    borderRadius:"50%"
                }}/>
               
              </div>
            </div>
            <div className="col-xl-9 ps-xl-5 col-lg-9 col-12 mt-5 mt-lg-0">
              <div className="section-title-3">
              <h6 className="mt-3">NAGINKUMAR VALLBHDAS BHOJANI </h6>
              <p>(Chairman – Shree Gita Group) </p>
                {/* <h6>Core Features</h6> */}
                {/* <h2>About Raw Cotton </h2> */}
                <p className='pt-2'>
                He’s the founder of the company and established the manufacturing unit in 1976. He is at the helm of the SHREE GITA Group. A born leader, under his visionary and experience the company has earned a reputation of being one of the best companies in the agro processing sector. 
                </p>
              
                <p  className='pt-2'>
                He is blessed with the acumen to see opportunities where none apparently exist, the courage to take the untrodden path and the determination to see his vision through to fruition.  
                </p>
               
                <p  className='pt-2'>
                He looks after the over all administration of the company and guides his both the sons, in their respective fields so as to help them getting the best of knowledge. His works include over all Administration, Dealing with government agencies, Financial Institutions, and Green House of the factory. You can term his the Financial Power house of the Company. 
                </p>
          
                <p  className='pt-2'>
                Thanking You, 
                </p>
              </div>
            </div>
          </div>
          <div className="row  ">
            <div className="col-xl-3 col-lg-3 pe-xl-4 col-12"  style={{
                display:"flex",
              justifyContent:"center"
              }}>
              <div className="content-block-img pt-4 " >
                <img src={coreImg2} alt=""  style={{
                    maxWidth:"100%",
                    borderRadius:"50%"
                }}/>
               
              </div>
            </div>
            <div className="col-xl-9 ps-xl-5 col-lg-9 col-12 mt-5 mt-lg-0">
              <div className="section-title-3">
              <h6 className="mt-3">MANISH NAGINKUMAR BHOJANI </h6>
              <p>(MD & CEO – Shree Gita Group) </p>
                {/* <h6>Core Features</h6> */}
                {/* <h2>About Raw Cotton </h2> */}
                <p className='pt-2'>
                After joining the business under his guidance the company made expansion plans to go in to diversification with forward and backward integration. Under his visionary the edible oil refining unit was set up which started its commercial production in F.Y. 2004-2005. 
                </p>
              
                <p  className='pt-2'>
                Under his vision only SHREE GITA was the 1st company in INDIA who installed the FULLY AUTOMATIC GINNNG-PRESSING PLANT of M/s BAJAJ STEEL INDUSTRIES LTD, NAGPUR. The plant commenced its commercial production in December 2005. 
                </p>
               
                <p  className='pt-2'>
                From systematically profiling the company and its diverse interests in the business to assisting the company in its various networking forums. He has played an instrumental role in the SHREE GITA Group. 
                </p>
                <p  className='pt-2'>
                He looks after the over all sales and purchase of the company along with that he also is always determined to adopt new technology which shall be beneficial in reaping high profits for the company. 
                </p>
          
                <p  className='pt-2'>
                Thanking You, 
                </p>
              </div>
            </div>
          </div>
          <div className="row  ">
            <div className="col-xl-3 col-lg-3 pe-xl-4 col-12"  style={{
                display:"flex",
                  justifyContent:"center"
              }}>
              <div className="content-block-img  pt-4" >
                <img src={coreImg3} alt=""  style={{
                    maxWidth:"100%",
                    borderRadius:"50%"
                }}/>
               
              </div>
            </div>
            <div className="col-xl-9 ps-xl-5 col-lg-9 col-12 mt-5 mt-lg-0">
              <div className="section-title-3">
              <h6 className="mt-3">CHETAN NAGINKUMAR BHOJANI</h6>
              <p>(Export Manager – Shree Gita Group) </p>
                {/* <h6>Core Features</h6> */}
                {/* <h2>About Raw Cotton </h2> */}
                <p className='pt-2'>
                After joining business, under his vision the company has successfully completed the expansion of the crushing division (Oil Mill Division), under his vision the company has achieved success of ten folds capacity expansion in seed crushing. 
                </p>
              
                <p  className='pt-2'>
                His scope of works include Administration Along with Shri NAGINBHAI; Corporate Communications, Human Resources and Back Office Operation which include Dispatch, Customer Orientation. The entire team of accounts is being handled under his supervision. 
                </p>
               
                <p  className='pt-2'>
                Along with the same the Supervision of Creative works like designing materials for products, Ad Designing, Ad campaigning etc for the company is managed by him. 
                </p>
             
          
                <p  className='pt-2'>
                Thanking You, 
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    
    </>
  )
}

export default Management
